"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateOrder = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const OrderStateEnum_1 = require("../../enums/OrderStateEnum");
const StateActiveDrivers_1 = require("./StateActiveDrivers");
const StateProfile_1 = require("../profiles/StateProfile");
const StateDriver_1 = require("../directory/StateDriver");
class StateOrder extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageOrder, "Order", true);
        this._stateSelectInitialized = false;
        const c = this.page.ctrls;
        c.btnChangePrice.onclick = () => this._tryChangePrice();
        c.btnUntake.onclick = () => this._tryUntake();
        c.btnTake.onclick = () => this._tryTake();
        c.btnCancel.onclick = () => this._tryCancel();
        c.btnComplete.onclick = () => this._tryComplete();
        c.btnChangeState.onclick = () => this._tryChangeStateFromSelect();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (!args)
                return gs_1.StateRunResultEnum.Failed;
            if (args.id)
                this._order = yield this.lockgui(this.app.api.admin.activeManager.getOrder(args.id));
            if (!this._order)
                return gs_1.StateRunResultEnum.Failed;
            this._urlArgs["id"] = this._order.id.toString();
            yield this.fill();
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._order)
                this.setLabel(this.title + ` #${this._order.id}`);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const fromLocation = this._order.route.locations[0];
            const toLocation = this._order.route.locations[this._order.route.locations.length - 1];
            const ctrl = this.page.ctrls;
            ctrl.lOrderInfo.html = "";
            const vehicleTypeName = yield this._getVehicleTypeName(this._order.vehicleTypeId);
            const createdAt = this._formatDateTime(this._order.created);
            const stateText = this._order.state
                ? this._safeText(this._order.state)
                : "—";
            const fromAddress = this._safeText((_a = fromLocation === null || fromLocation === void 0 ? void 0 : fromLocation.addressFull) !== null && _a !== void 0 ? _a : "—") || "—";
            const toAddress = this._safeText((_b = toLocation === null || toLocation === void 0 ? void 0 : toLocation.addressFull) !== null && _b !== void 0 ? _b : "—") || "—";
            const startTime = this._formatDateTime(this._order.route.departureTime);
            const portersCount = (_c = this._order.portersCount) !== null && _c !== void 0 ? _c : 0;
            const portersInfo = portersCount > 0 ? `Yes (${portersCount})` : "No";
            const paymentMethodInfo = this._formatPaymentMethod(this._order.paymentMethod);
            const infoLines = [];
            infoLines.push(`<b>Order info</b>`);
            infoLines.push(`State: ${stateText}`);
            infoLines.push(`Created: ${createdAt}`);
            if (vehicleTypeName)
                infoLines.push(`Vehicle type: ${vehicleTypeName}`);
            infoLines.push(`From: ${fromAddress}`);
            infoLines.push(`To: ${toAddress}`);
            infoLines.push(`Start time: ${startTime}`);
            infoLines.push(`Porters needed: ${portersInfo}`);
            infoLines.push(`Payment method: ${paymentMethodInfo}`);
            if (!this._order.finalPrice) {
                const estimated = (_d = this._formatPrice(this._order.estimatedPrice)) !== null && _d !== void 0 ? _d : this._safeText((_e = this._order.estimatedPrice) !== null && _e !== void 0 ? _e : "—");
                infoLines.push(`Est.price: ${estimated}`);
            }
            else {
                const finalVal = (_f = this._formatPrice(this._order.finalPrice)) !== null && _f !== void 0 ? _f : this._safeText((_g = this._order.finalPrice) !== null && _g !== void 0 ? _g : "—");
                infoLines.push(`Final price: ${finalVal}`);
            }
            if (this._order.changes && this._order.changes.length > 0) {
                infoLines.push(StateOrder._OrderInfoSpacer);
                infoLines.push(`<b>Changes</b>:`);
                for (const change of this._order.changes) {
                    const state = this._safeText(change.state);
                    const comment = change.comment
                        ? ` ${this._safeText(change.comment)}`
                        : "";
                    infoLines.push(`${gs.date.getShortTime(change.created)} ${state}${comment}`.trim());
                }
            }
            if (this._order.priceChanges && this._order.priceChanges.length > 0) {
                infoLines.push(StateOrder._OrderInfoSpacer);
                infoLines.push(`<b>Price changes</b>:`);
                for (const change of this._order.priceChanges) {
                    let delta = change.priceChange.toString();
                    if (change.priceChange > 0)
                        delta = "+" + delta;
                    const reason = this._safeText(change.reason);
                    const line = reason
                        ? `${gs.date.getShortTime(change.created)} ${delta} ${reason}`
                        : `${gs.date.getShortTime(change.created)} ${delta}`;
                    infoLines.push(line);
                }
            }
            if (this._order.finalPrice) {
                infoLines.push(StateOrder._OrderInfoSpacer);
                infoLines.push(`<b>Check</b>:`);
                const checkRaw = this._safeText((_h = this._order.finalCheck) !== null && _h !== void 0 ? _h : "");
                const checkText = gs.text.replaceAll(gs.text.replaceAll(checkRaw, "\r\n", "\n"), "\n", "<br>");
                infoLines.push(checkText);
            }
            const showCouponInfo = (this._order.couponCode && this._order.couponCode.trim().length > 0) ||
                this._hasNumberValue(this._order.couponPercent) ||
                this._hasNumberValue(this._order.discountEstimatedAmount) ||
                this._hasNumberValue(this._order.discountFinalAmount);
            if (showCouponInfo) {
                const couponLines = [];
                if (this._order.couponCode)
                    couponLines.push(`Code: ${this._safeText(this._order.couponCode)}`);
                const couponPercent = this._formatPercent(this._order.couponPercent);
                if (couponPercent)
                    couponLines.push(`Percent: ${couponPercent}`);
                const baseEstimated = this._formatPrice(this._order.baseEstimatedPrice);
                if (baseEstimated)
                    couponLines.push(`Base estimated price: ${baseEstimated}`);
                const discountEstimated = this._formatPrice(this._order.discountEstimatedAmount);
                if (discountEstimated)
                    couponLines.push(`Discount estimated amount: ${discountEstimated}`);
                const payableEstimated = this._formatPrice(this._order.payableEstimatedPrice);
                if (payableEstimated)
                    couponLines.push(`Payable estimated price: ${payableEstimated}`);
                const baseFinal = this._formatPrice(this._order.baseFinalPrice);
                if (baseFinal)
                    couponLines.push(`Base final price: ${baseFinal}`);
                const discountFinal = this._formatPrice(this._order.discountFinalAmount);
                if (discountFinal)
                    couponLines.push(`Discount final amount: ${discountFinal}`);
                const payableFinal = this._formatPrice(this._order.payableFinalPrice);
                if (payableFinal)
                    couponLines.push(`Payable final price: ${payableFinal}`);
                if (couponLines.length > 0) {
                    infoLines.push(StateOrder._OrderInfoSpacer);
                    infoLines.push(`<b>Coupon</b>:`);
                    infoLines.push(...couponLines);
                }
            }
            ctrl.lOrderInfo.html = infoLines
                .map((line) => line === StateOrder._OrderInfoSpacer
                ? `<div class="order-info-block__spacer" aria-hidden="true"></div>`
                : `<div class="order-info-block__line">${line}</div>`)
                .join("");
            const stateSelect = this._getStateSelectElement();
            if (stateSelect) {
                this._ensureStateSelectOptions(stateSelect);
                this._setStateSelectValue(stateSelect, this._order.state);
            }
            yield this._updateParticipants();
            this._renderParticipants();
            ctrl.formChangePrice.hide();
            if (this._order.isActive) {
                ctrl.formChangePrice.show();
            }
            this._updateControlButtons();
        });
    }
    _tryChangePrice() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.page.ctrls.formChangePrice.getFormData();
            if (!data)
                return;
            const req = new models_1.ChangePriceOrderRequest(data);
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.changeActiveOrderPrice(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.page.ctrls.formChangePrice.fillFormData({
                priceDelta: 0,
                reason: "",
            });
            yield this.fill();
        });
    }
    _tryUntake() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            if (!this._order.driverId) {
                new modalCom.DialogOk("There is no driver already").show();
                return;
            }
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.untakeActiveOrderForDriver(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.fill();
            yield new modalCom.DialogOk("Driver unlinked").show();
        });
    }
    _tryTake() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            if (this._order.driverId) {
                new modalCom.DialogOk("Driver already linked").show();
                return;
            }
            const driver = yield StateActiveDrivers_1.StateActiveDrivers.SelectActiveDriver();
            if (!driver)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.takeActiveOrderForDriver(driver.driver.userId, req));
            if (!responce)
                return;
            this._order = responce;
            yield gs_1.StateGS.Run(StateOrder, { id: this._order.id });
            yield new modalCom.DialogOk("Driver linked").show();
        });
    }
    _tryCancel() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.cancelActiveOrder(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.fill();
        });
    }
    _tryComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order.isActive)
                return;
            const req = new models_1.OrderRequest();
            req.orderId = this._order.id;
            const responce = yield this.lockgui(this.app.api.admin.activeManager.completeActiveOrderAndWaitPay(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.fill();
        });
    }
    _updateParticipants() {
        return __awaiter(this, void 0, void 0, function* () {
            const customerId = this._order.customerId;
            if (customerId) {
                if (!this._customer || this._customer.id !== customerId) {
                    this._customer = yield this.app.api.admin.profiles.getUser(customerId);
                }
            }
            else {
                this._customer = undefined;
            }
            const driverId = this._order.driverId;
            if (driverId) {
                if (!this._driverInfo || this._driverInfo.driver.userId !== driverId) {
                    this._driverInfo = yield this.app.api.admin.directory.getDriver(driverId);
                }
            }
            else {
                this._driverInfo = undefined;
            }
        });
    }
    _renderParticipants() {
        const ctrl = this.page.ctrls;
        ctrl.linkCustomer.hide();
        ctrl.linkCustomer.attr("href", "#");
        ctrl.linkCustomer.el.onclick = null;
        ctrl.linkDriver.hide();
        ctrl.linkDriver.attr("href", "#");
        ctrl.linkDriver.el.onclick = null;
        if (this._customer) {
            const parts = [`#${this._customer.id}`];
            const name = `${this._customer.name || ""} ${this._customer.surname || ""}`.trim();
            if (name)
                parts.push(name);
            ctrl.lCustomer.text = parts.join(" ");
            const href = `?state=profile&id=${this._customer.id}`;
            ctrl.linkCustomer.attr("href", href);
            ctrl.linkCustomer.show();
            ctrl.linkCustomer.el.onclick = (ev) => {
                this._handleStateLink(ev, () => gs_1.StateGS.Run(StateProfile_1.StateProfile, { id: this._customer.id.toString() }));
            };
        }
        else if (this._order.customerId) {
            ctrl.lCustomer.text = `#${this._order.customerId}`;
        }
        else {
            ctrl.lCustomer.text = "—";
        }
        if (this._driverInfo) {
            const driverId = this._driverInfo.userShort.id || this._driverInfo.driver.userId;
            const parts = driverId ? [`#${driverId}`] : [];
            const name = `${this._driverInfo.userShort.name || ""} ${this._driverInfo.userShort.surname || ""}`.trim();
            if (name)
                parts.push(name);
            ctrl.lDriver.text = parts.length ? parts.join(" ") : name || "—";
            if (driverId) {
                const href = `?state=driver&id=${driverId}`;
                ctrl.linkDriver.attr("href", href);
                ctrl.linkDriver.show();
                ctrl.linkDriver.el.onclick = (ev) => {
                    this._handleStateLink(ev, () => gs_1.StateGS.Run(StateDriver_1.StateDriver, { id: driverId }));
                };
            }
            else {
                ctrl.linkDriver.hide();
            }
        }
        else if (this._order.driverId) {
            ctrl.lDriver.text = `#${this._order.driverId}`;
        }
        else {
            ctrl.lDriver.text = "Driver not assigned";
        }
    }
    _hasNumberValue(value) {
        if (value === null || value === undefined)
            return false;
        if (!Number.isFinite(value))
            return false;
        return Math.abs(value) > 0.000001;
    }
    _formatPrice(value) {
        if (value === null || value === undefined)
            return null;
        if (!Number.isFinite(value))
            return null;
        return value.toFixed(2);
    }
    _formatDateTime(date) {
        if (!date)
            return "—";
        const value = date instanceof Date ? date : new Date(date);
        return gs.date.getShortTime(value);
    }
    _safeText(value) {
        if (value === null || value === undefined)
            return "";
        return gs.text.clearHtmlToText(String(value));
    }
    _getVehicleTypeName(vehicleTypeId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!vehicleTypeId)
                return null;
            try {
                const vehicleType = yield this.app.astra.getVehiclesType(vehicleTypeId);
                if (!vehicleType)
                    return `#${vehicleTypeId}`;
                const parts = [];
                if (vehicleType.sizeClass)
                    parts.push(vehicleType.sizeClass);
                if (vehicleType.size)
                    parts.push(`w${vehicleType.size.width} : l${vehicleType.size.length} : h${vehicleType.size.height}`);
                if (typeof vehicleType.volume === "number" &&
                    Number.isFinite(vehicleType.volume))
                    parts.push(`Volume: ${vehicleType.volume}`);
                if (typeof vehicleType.payload === "number" &&
                    Number.isFinite(vehicleType.payload))
                    parts.push(`Payload: ${vehicleType.payload}`);
                const label = parts.length ? parts.join(" | ") : `#${vehicleTypeId}`;
                return this._safeText(label);
            }
            catch (_a) {
                return `#${vehicleTypeId}`;
            }
        });
    }
    _formatPercent(value) {
        if (value === null || value === undefined)
            return null;
        if (!Number.isFinite(value))
            return null;
        return `${value.toFixed(2)}%`;
    }
    _formatPaymentMethod(method) {
        if (!method)
            return "—";
        const parts = [];
        if (method.provider)
            parts.push(this._safeText(method.provider));
        if (method.type)
            parts.push(this._safeText(method.type));
        if (method.description)
            parts.push(this._safeText(method.description));
        if (method.brand)
            parts.push(this._safeText(method.brand));
        if (method.id)
            parts.push(`#${this._safeText(method.id)}`);
        return parts.length ? parts.join(", ") : "—";
    }
    _updateControlButtons() {
        var _a;
        const ctrl = this.page.ctrls;
        ctrl.blockControl.show();
        ctrl.btnChangeState.show();
        ctrl.selectNewState.show();
        if (!((_a = this._order) === null || _a === void 0 ? void 0 : _a.isActive)) {
            ctrl.btnComplete.hide();
            ctrl.btnCancel.hide();
            ctrl.btnTake.hide();
            ctrl.btnUntake.hide();
            return;
        }
        ctrl.btnComplete.show();
        ctrl.btnCancel.show();
        if (this._order.driverId) {
            ctrl.btnTake.hide();
            ctrl.btnUntake.show();
        }
        else {
            ctrl.btnTake.show();
            ctrl.btnUntake.hide();
        }
    }
    _tryChangeStateFromSelect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._order)
                return;
            const select = this._getStateSelectElement();
            if (!select)
                return;
            const rawValue = select.value.trim();
            if (!rawValue) {
                yield new modalCom.DialogOk("Select target status").show();
                return;
            }
            const nextState = Number(rawValue);
            if (!Number.isFinite(nextState)) {
                yield new modalCom.DialogOk("Selected status is invalid").show();
                return;
            }
            const currentState = StateOrder._resolveStateValue(this._order.state);
            if (currentState === nextState) {
                yield new modalCom.DialogOk("Order already has this status").show();
                return;
            }
            const req = new models_1.OrderStateChangeRequest();
            req.orderId = this._order.id;
            req.newState = nextState.toString();
            const responce = yield this.lockgui(this.app.api.admin.activeManager.changeActiveState(req));
            if (!responce)
                return;
            this._order = responce;
            yield this.fill();
        });
    }
    _getStateSelectElement() {
        var _a;
        const element = (_a = this.page.ctrls.selectNewState) === null || _a === void 0 ? void 0 : _a.el;
        return element instanceof HTMLSelectElement ? element : null;
    }
    _ensureStateSelectOptions(select) {
        if (this._stateSelectInitialized)
            return;
        select.innerHTML = "";
        select.append(new Option("Select status", ""));
        for (const option of StateOrder._OrderStates) {
            select.append(new Option(option.label, option.value.toString()));
        }
        this._stateSelectInitialized = true;
    }
    _setStateSelectValue(select, state) {
        const resolved = StateOrder._resolveStateValue(state);
        select.value = resolved !== undefined ? resolved.toString() : "";
    }
    static _resolveStateValue(state) {
        const enumObj = OrderStateEnum_1.OrderStateEnum;
        if (typeof state === "number" && Number.isFinite(state)) {
            return enumObj[state] !== undefined ? state : undefined;
        }
        if (typeof state === "string") {
            const numeric = Number(state);
            if (Number.isFinite(numeric) && enumObj[numeric] !== undefined) {
                return numeric;
            }
            const enumValue = enumObj[state];
            if (typeof enumValue === "number")
                return enumValue;
        }
        return undefined;
    }
    static _createOrderStates() {
        const enumObj = OrderStateEnum_1.OrderStateEnum;
        const result = [];
        for (const [key, value] of Object.entries(enumObj)) {
            if (typeof value !== "number")
                continue;
            const label = `${StateOrder._humanizeStateName(key)} (#${value})`;
            result.push({ value, label });
        }
        result.sort((a, b) => a.value - b.value);
        return result;
    }
    static _humanizeStateName(name) {
        return name
            .replace(/_/g, " ")
            .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
            .replace(/\s+/g, " ")
            .trim();
    }
    _handleStateLink(ev, action) {
        if (ev.button === 0 &&
            !ev.ctrlKey &&
            !ev.shiftKey &&
            !ev.metaKey &&
            !ev.altKey) {
            ev.preventDefault();
            action();
        }
    }
}
exports.StateOrder = StateOrder;
StateOrder.StateName = "order";
StateOrder._OrderInfoSpacer = "__ORDER_INFO_SPACER__";
StateOrder._OrderStates = StateOrder._createOrderStates();
//# sourceMappingURL=StateOrder.js.map